<template>
  <div>
      <div class="container-text-processos">
        <h6 class="text-titulo-processos">Licitações</h6>
        <h2 class="text-sub-titulo-processos">Pregões Eletrônicos</h2>
      </div>
      <listagem-processos-licitacao-pesquisa :filtros="filtros" @buscarComFiltros="buscarProcessos"/>
      <listagem-processos-licitacao-tabela
          :itens="itens"
          :paginas="paginas"
          :total-itens="totalItens"
          :paginacao="paginacao"
          @paginar="paginar"
          @acessarProcesso="acessar"
      />
  </div>
</template>

<script>

import ListagemProcessosLicitacaoPesquisa
  from '@/views/pages/commons/portal/licitacao/listagemProcessosLicitacao/ListagemProcessosLicitacaoPesquisa.vue'
import ListagemProcessosLicitacaoTabela
  from '@/views/pages/commons/portal/licitacao/listagemProcessosLicitacao/ListagemProcessosLicitacaoTabela.vue'
import TodasLicitacoesTabela from '@/views/pages/commons/licitacao/consulta-licitacoes/LicitacoesDisponiveisTabela.vue'
import {mapActions} from 'vuex'
import {actionTypes} from '@/core/constants'

export default {
  name: 'ListagemProcessosLicitacao',
  components: {TodasLicitacoesTabela, ListagemProcessosLicitacaoTabela, ListagemProcessosLicitacaoPesquisa},
  data() {
    return {
      filtros: {
        objeto: null,
        estado: null,
        idMunicipio: null,
        status: null
      },
      paginacao:{
        size: 10,
        page: 1,
      },
      itens: [],
      paginas: 0,
      totalItens: 10,
    }
  },
  async mounted(){
    await this.buscarProcessos()
  },
  methods:{
    ...mapActions([
      actionTypes.BUSCAR_PROCESSOS_PUBLICADOS
    ]),
    async buscarProcessos(){
      const resultado = await this.buscarProcessosPublicados(Object.assign(this.paginacao, this.filtros))
      this.itens = resultado.content
      this.paginas = resultado.totalPages
      this.totalItens = resultado.totalElements
    },
    paginar(paginacao) {
      this.paginacao = paginacao
      this.buscarProcessos()
    },
    acessar(id){
      this.$router.push({name: 'paginaInternaLicitacaoProcesso', params: {id}})
    },
  }
}
</script>

<style scoped lang="stylus">

.text-titulo-processos
  font-size 14px
  color #fff
  font-weight 700
  text-transform uppercase
  margin-bottom 10px

.text-sub-titulo-processos
  font-size 42px
  font-weight 600
  color: #fff

</style>